import React, { useMemo } from 'react'
import { System } from '@leverege/api-redux'
import { SystemTranslationScreen as SysTranslationScreen } from '@leverege/api-ui-i18n-management'

export default function SystemTranslationScreen( props ) {
  const { match : { params : { systemId } } } = props

  const delegate = useMemo( () => {
    return System( systemId )
  }, [ systemId ] )
  
  return (
    <SysTranslationScreen delegate={delegate} />
  )
}
